import { useState } from 'react';
import { getThemePreference, setThemePreference, type ThemePreference } from '../../../infrastructure/browser/theme';

// La elección de Ajustes: automático, claro u oscuro.
export function useThemePreference() {
  const [preference, setPreference] = useState<ThemePreference>(getThemePreference);
  const choose = (pref: ThemePreference) => {
    setThemePreference(pref);
    setPreference(pref);
  };
  return { preference, choose };
}
